export default "__VITE_ASSET__BR3pkYn2__"